import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import { primaryColor, dangerColor, successColor } from "assets/jss/material-dashboard-pro-react.jsx";

const styles = {
  formControl: {
    margin: "0 0 17px 0",
    paddingTop: "27px",
    position: "relative",
    verticalAlign: "unset"
  },
  labelRoot: {
    color: "#AAAAAA",
    fontWeight: "400",
    fontSize: "14px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.42857",
    top: "10px",
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left"
  },
  labelError:   { color: dangerColor  + " !important" },
  labelSuccess: { color: successColor + " !important" },
  inputWrap: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      borderBottom: "1px solid #D2D2D2",
      pointerEvents: "none"
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      borderBottom: `2px solid ${primaryColor}`,
      transform: "scaleX(0)",
      transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
      pointerEvents: "none"
    },
    "&.focused::after": { transform: "scaleX(1)" }
  },
  helpText: { color: "#AAAAAA", fontSize: "12px" },
  helpTextError:   { color: dangerColor   },
  helpTextSuccess: { color: successColor  }
};

class CustomDatePicker extends Component {
  state = { focused: false };

  handleFocus = () => this.setState({ focused: true });
  handleBlur  = () => this.setState({ focused: false });

  handleChange = momentOrString => {
    const { inputProps, dateFormat, timeFormat } = this.props;
    if (!inputProps || !inputProps.onChange) return;

    const resolvedDateFormat = dateFormat !== undefined ? dateFormat : "YYYY-MM-DD";
    const resolvedTimeFormat = timeFormat !== undefined ? timeFormat : false;

    let strValue;
    if (momentOrString && typeof momentOrString.format === "function") {
      if (resolvedDateFormat === false) {
        strValue = momentOrString.format(
          typeof resolvedTimeFormat === "string" ? resolvedTimeFormat : "HH:mm"
        );
      } else {
        strValue = momentOrString.format(
          typeof resolvedDateFormat === "string" ? resolvedDateFormat : "YYYY-MM-DD"
        );
      }
    } else {
      strValue = momentOrString || "";
    }

    inputProps.onChange({ target: { value: strValue } });
  };

  render() {
    const {
      classes, formControlProps, labelText, id, labelProps,
      inputProps, error, success, helpText, hidden,
      dateFormat, timeFormat
    } = this.props;
    const { focused } = this.state;

    const { onChange: _onChange, value, style: _style, ...restInputProps } = inputProps || {};

    const resolvedDateFormat = dateFormat !== undefined ? dateFormat : "YYYY-MM-DD";
    const resolvedTimeFormat = timeFormat !== undefined ? timeFormat : false;

    const labelClass = [
      classes.labelRoot,
      error   ? classes.labelError   : "",
      success ? classes.labelSuccess : ""
    ].filter(Boolean).join(" ");

    const helpClass = [
      classes.helpText,
      error   ? classes.helpTextError   : "",
      success ? classes.helpTextSuccess : ""
    ].filter(Boolean).join(" ");

    const formControlClass = [
      classes.formControl,
      formControlProps && formControlProps.className
    ].filter(Boolean).join(" ");

    return (
      <FormControl
        {...formControlProps}
        className={formControlClass}
        style={{ ...(formControlProps && formControlProps.style) }}
        hidden={hidden}
      >
        {labelText && (
          <InputLabel
            shrink
            className={labelClass}
            htmlFor={id}
            {...labelProps}
          >
            {labelText}
          </InputLabel>
        )}

        <div className={`${classes.inputWrap}${focused ? " focused" : ""}`}>
          <Datetime
            value={value || ""}
            dateFormat={resolvedDateFormat}
            timeFormat={resolvedTimeFormat}
            onChange={this.handleChange}
            inputProps={{
              id,
              onFocus: this.handleFocus,
              onBlur:  this.handleBlur,
              style: {
                border:      "none",
                outline:     "none",
                background:  "transparent",
                width:       "100%",
                padding:     "4px 0 5px",
                fontSize:    "14px",
                fontFamily:  '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight:  "400",
                color:       "#495057",
                cursor:      "pointer",
                lineHeight:  "1.42857"
              },
              ...restInputProps
            }}
          />
        </div>

        {helpText && (
          <FormHelperText id={`${id}-text`} className={helpClass}>
            {helpText}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
}

CustomDatePicker.defaultProps = { dateFormat: "YYYY-MM-DD", timeFormat: false };

CustomDatePicker.propTypes = {
  classes:         PropTypes.object.isRequired,
  labelText:       PropTypes.node,
  labelProps:      PropTypes.object,
  id:              PropTypes.string,
  inputProps:      PropTypes.object,
  formControlProps:PropTypes.object,
  error:           PropTypes.bool,
  success:         PropTypes.bool,
  white:           PropTypes.bool,
  helpText:        PropTypes.node,
  hidden:          PropTypes.bool,
  dateFormat:      PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  timeFormat:      PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default withStyles(styles)(CustomDatePicker);
